/*! tailwindcss v4.3.1 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
    --font-standard: var(--font-standard);
    --font-number: var(--font-number);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  ::-webkit-calendar-picker-indicator {
    line-height: 1;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline {
    display: inline;
  }
  .inline-flex {
    display: inline-flex;
  }
  .table {
    display: table;
  }
  .transform {
    transform: var(--tw-rotate-x,) var(--tw-rotate-y,) var(--tw-rotate-z,) var(--tw-skew-x,) var(--tw-skew-y,);
  }
  .resize {
    resize: both;
  }
  .border {
    border-style: var(--tw-border-style);
    border-width: 1px;
  }
  .uppercase {
    text-transform: uppercase;
  }
  .italic {
    font-style: italic;
  }
  .tabular-nums {
    --tw-numeric-spacing: tabular-nums;
    font-variant-numeric: var(--tw-ordinal,) var(--tw-slashed-zero,) var(--tw-numeric-figure,) var(--tw-numeric-spacing,) var(--tw-numeric-fraction,);
  }
  .underline {
    text-decoration-line: underline;
  }
  .filter {
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
  }
  .transition {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to, opacity, box-shadow, transform, translate, scale, rotate, filter, -webkit-backdrop-filter, backdrop-filter, display, content-visibility, overlay, pointer-events;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
}
:root {
  --primary-hint: hsl(146 30% 96%);
  --primary-verylight: hsl(146 28% 89%);
  --primary-light: hsl(146 27% 78%);
  --primary-mediumlight: hsl(146 26% 66%);
  --primary-base: hsl(146 25% 57%);
  --primary-mediumdark: hsl(146 26% 43%);
  --primary-dark: hsl(146 28% 29%);
  --primary-verydark: hsl(146 30% 20%);
  --primary-nearblack: hsl(146 32% 11%);
  --mono-hint: #fafafa;
  --mono-verylight: #f5f5f5;
  --mono-light: #e5e5e5;
  --mono-mediumlight: #d4d4d4;
  --mono-base: #737373;
  --mono-mediumdark: #525252;
  --mono-dark: #404040;
  --mono-verydark: #262626;
  --mono-nearblack: #0a0a0a;
  --accent2-hint: #fffbeb;
  --accent2-base: #e99904;
  --accent2-nearblack: #92400e;
  --destructive-hint: #fef2f2;
  --destructive-base: #c90000;
  --destructive-dark: #b91c1c;
  --background: rgba(0, 53, 0, 0.035);
  --foreground: var(--mono-nearblack);
  --card: var(--mono-hint);
  --card-foreground: var(--mono-nearblack);
  --popover: var(--mono-hint);
  --popover-foreground: var(--mono-nearblack);
  --sidebar: var(--mono-hint);
  --sidebar-foreground: var(--mono-nearblack);
  --topbar-bg: var(--sidebar);
  --border: var(--mono-light);
  --input: var(--mono-light);
  --panel: #f3f3f3;
  --input-bg: var(--card);
  --input-fg: var(--mono-nearblack);
  --muted: var(--primary-verylight);
  --muted-foreground: var(--mono-mediumdark);
  --secondary: hsl(146 28% 80%);
  --secondary-foreground: var(--mono-nearblack);
  --accent: hsl(146 30% 92%);
  --accent-foreground: var(--mono-nearblack);
  --nav-hover: hsl(146 28% 89%);
  --nav-group-rule: hsl(146 28% 29% / 0.28);
  --primary: var(--primary-dark);
  --primary-foreground: var(--mono-hint);
  --primary-hover: var(--primary-verydark);
  --primary-active: var(--primary-nearblack);
  --primary-blocked: var(--primary-mediumlight);
  --primary-text: var(--primary-dark);
  --ring: var(--primary-dark);
  --ring-width: 2px;
  --destructive: var(--destructive-base);
  --destructive-foreground: var(--mono-hint);
  --destructive-hover: var(--destructive-hint);
  --warning: var(--accent2-base);
  --success: #109410;
  --scrim: rgba(0, 0, 0, 0.4);
  --overlay-scrollbar-thumb: var(--mono-base);
  --overlay-scrollbar-track: rgba(0, 0, 0, 0.07);
  --radius: 6px;
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-regular.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-500.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-600.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/fonts/noto-sans-v42-latin_latin-ext-700.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans Mono';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/fonts/noto-sans-mono-v37-latin_latin-ext-regular.woff2') format('woff2');
}
@font-face {
  font-family: 'Noto Sans Mono';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/fonts/noto-sans-mono-v37-latin_latin-ext-700.woff2') format('woff2');
}
:root {
  --font-standard: 'Noto Sans', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  --font-number: 'Noto Sans Mono', ui-monospace, 'Cascadia Code', Menlo, Consolas, monospace;
  --fs-xs: 12px;
  --fs-sm: 13px;
  --fs-base: 15px;
  --fs-title: 19px;
  --fs-heading: 24px;
  --fs-page-title: var(--fs-title);
  --ff-page-title: var(--font-standard);
  --fs-nav-item: var(--fs-base);
  --ff-nav-item: var(--font-standard);
  --ff-numeric-value: var(--font-number);
  --fs-numeric-value: var(--fs-base);
}
.dash-spinner {
  display: inline-block;
  flex: 0 0 auto;
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: dash-spin 700ms linear infinite;
}
@keyframes dash-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .dash-spinner {
    animation-duration: 2.4s;
  }
}
@media (max-width: 639px) {
  .dash-topbar-title {
    display: none;
  }
}
.dash-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.dash-body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  position: relative;
}
.dash-main {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.dash-menu {
  flex: 0 0 auto;
  display: flex;
}
.dash-menu > * {
  min-height: 100%;
}
@media (max-width: 1023px) {
  .dash-menu {
    position: absolute;
    inset: 0 auto 0 0;
    z-index: 40;
    transform: translateX(-100%);
    visibility: hidden;
    transition: transform 180ms ease, visibility 180ms ease;
    box-shadow: 0 0 24px rgb(0 0 0 / 18%);
  }
  .dash-menu[data-open='true'] {
    transform: translateX(0);
    visibility: visible;
  }
  .dash-scrim {
    position: absolute;
    inset: 0;
    z-index: 30;
    background: rgb(0 0 0 / 35%);
    border: 0;
    padding: 0;
    opacity: 0;
    pointer-events: none;
    transition: opacity 600ms ease;
  }
  .dash-scrim[data-open='true'] {
    opacity: 1;
    pointer-events: auto;
    transition: opacity 2000ms ease;
  }
}
@media (min-width: 1024px) {
  .dash-scrim {
    display: none;
  }
}
@media (prefers-reduced-motion: reduce) {
  .dash-menu {
    transition: none;
  }
  .dash-scrim, .dash-scrim[data-open='true'] {
    transition-duration: 1ms;
  }
}
.dash-axes {
  display: flex;
  align-items: center;
  gap: 10px 14px;
  flex-wrap: wrap;
  padding: 10px 24px;
  border-bottom: 1px solid var(--border);
  flex: 0 0 auto;
}
.dash-axis {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.dash-axes select {
  min-height: 44px;
}
@media (max-width: 639px) {
  .dash-axes {
    padding: 10px 14px;
  }
  .dash-axis {
    flex: 1 1 calc(50% - 14px);
  }
  .dash-axis select {
    flex: 1 1 auto;
    min-width: 0;
  }
}
.dash-page {
  padding: 24px;
  max-width: 1000px;
}
.dash-page--wide {
  max-width: 1320px;
}
@media (max-width: 639px) {
  .dash-page {
    padding: 14px;
  }
}
.dash-metrics {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}
@media (max-width: 767px) {
  .dash-metrics {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
.dash-tiles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
@media (max-width: 767px) {
  .dash-tiles {
    grid-template-columns: 1fr;
  }
}
.dash-split {
  display: grid;
  grid-template-columns: minmax(220px, 300px) minmax(0, 1fr);
  gap: 20px;
  align-items: start;
}
@media (max-width: 1023px) {
  .dash-split {
    grid-template-columns: minmax(0, 1fr);
  }
}
.dash-rank {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.dash-rank-row {
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-width: 0;
}
.dash-rank-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
}
.dash-rank-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.dash-rank-value {
  flex: 0 0 auto;
  font-family: var(--font-number);
}
.dash-rank-track {
  height: 8px;
  border-radius: 999px;
  background: var(--muted);
  overflow: hidden;
}
.dash-rank-fill {
  height: 100%;
  border-radius: 999px;
  background: var(--primary-dark);
}
.dash-grid-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 76px 96px 84px 118px;
  gap: 10px;
  align-items: center;
}
.dash-title-text {
  white-space: normal;
  overflow-wrap: anywhere;
  min-width: 0;
}
@media (max-width: 767px) {
  .dash-grid-row {
    grid-template-columns: 1fr;
    gap: 6px;
    padding-bottom: 10px;
  }
  .dash-grid-row > .dash-cell {
    display: flex;
    justify-content: space-between;
    gap: 12px;
  }
  .dash-cell::before {
    content: attr(data-label);
    color: var(--muted-foreground);
    font-size: var(--fs-xs);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .dash-cell[data-label='']::before {
    display: none;
  }
  .dash-cell[data-label=''] {
    justify-content: flex-start;
    margin-bottom: 4px;
    padding-bottom: 6px;
    border-bottom: 1px solid var(--border);
    font-size: var(--fs-base);
  }
  .dash-grid-head {
    display: none;
  }
}
.dash-daystrip {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}
.dash-daystrip-inner {
  display: flex;
  align-items: flex-end;
  min-width: 100%;
}
.dash-day {
  flex: 1 1 0;
  min-width: 1px;
}
@media (max-width: 767px) {
  .dash-day {
    flex: 0 0 auto;
    min-width: 9px;
  }
}
.dash-tree {
  display: flex;
  flex-direction: column;
}
.dash-tree-row {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  min-height: 40px;
  padding: 4px 8px;
  border: 0;
  background: none;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  border-radius: var(--radius);
}
.dash-tree-row[data-selected='true'] {
  background: var(--primary-verylight);
  font-weight: 600;
}
.dash-tree-twist {
  flex: 0 0 auto;
  width: 28px;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  background: none;
  color: var(--muted-foreground);
  cursor: pointer;
  border-radius: var(--radius);
}
.dash-tree-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  flex: 1 1 auto;
}
@media (max-width: 1023px) {
  .dash-sheet {
    position: fixed;
    inset: auto 0 0 0;
    z-index: 60;
    max-height: 75vh;
    overflow: auto;
    background: var(--card);
    border-top: 1px solid var(--border);
    border-radius: var(--radius) var(--radius) 0 0;
    box-shadow: 0 -8px 28px rgb(0 0 0 / 22%);
    padding: 8px 12px calc(12px + env(safe-area-inset-bottom));
  }
  .dash-sheet-scrim {
    position: fixed;
    inset: 0;
    z-index: 50;
    background: rgb(0 0 0 / 35%);
    border: 0;
    padding: 0;
  }
}
@media (min-width: 1024px) {
  .dash-sheet-scrim {
    display: none;
  }
}
@media (max-width: 1023px) {
  .dash-tree-row, .dash-tree-twist {
    min-height: 44px;
  }
}
@layer base {
  * {
    border-color: var(--border);
  }
  *:focus-visible {
    outline: var(--ring-width) solid var(--ring);
    outline-offset: 2px;
  }
}
html, body, #root {
  height: 100%;
}
body {
  margin: 0;
  background: var(--background);
  color: var(--foreground);
  font-family: var(--font-standard);
  font-size: var(--fs-base);
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
}
.admin-option {
  background: transparent;
}
@media (hover: hover) {
  .admin-option:hover {
    background: var(--nav-hover);
  }
}
.admin-option[data-active] {
  background: var(--secondary);
}
.admin-option[data-disabled] {
  background: transparent;
}
.admin-btn {
  background: transparent;
}
@media (hover: hover) {
  .admin-btn:not(:disabled):hover {
    background: var(--nav-hover);
  }
}
.admin-btn-primary {
  background: var(--primary);
}
@media (hover: hover) {
  .admin-btn-primary:not(:disabled):hover {
    background: var(--primary-hover);
  }
}
.admin-btn-danger {
  background: transparent;
}
@media (hover: hover) {
  .admin-btn-danger:not(:disabled):hover {
    background: var(--destructive-hover);
  }
}
.admin-pill {
  border: 1px solid var(--accent2-base);
  background: var(--accent2-hint);
  color: var(--accent2-nearblack);
  border-radius: 999px;
  padding: 0 8px;
  font-size: var(--fs-xs);
  font-weight: 400;
  white-space: nowrap;
}
.yoreflix-no-scrollbar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.yoreflix-no-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}
:root {
  --press-wash: rgba(0, 0, 0, 0.1);
}
[data-pressed] {
  box-shadow: inset 0 0 0 100vmax var(--press-wash);
}
@property --tw-rotate-x {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-y {
  syntax: "*";
  inherits: false;
}
@property --tw-rotate-z {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-x {
  syntax: "*";
  inherits: false;
}
@property --tw-skew-y {
  syntax: "*";
  inherits: false;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-ordinal {
  syntax: "*";
  inherits: false;
}
@property --tw-slashed-zero {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-figure {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-spacing {
  syntax: "*";
  inherits: false;
}
@property --tw-numeric-fraction {
  syntax: "*";
  inherits: false;
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-rotate-x: initial;
      --tw-rotate-y: initial;
      --tw-rotate-z: initial;
      --tw-skew-x: initial;
      --tw-skew-y: initial;
      --tw-border-style: solid;
      --tw-ordinal: initial;
      --tw-slashed-zero: initial;
      --tw-numeric-figure: initial;
      --tw-numeric-spacing: initial;
      --tw-numeric-fraction: initial;
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
    }
  }
}
